export default __webpack_public_path__ + "static/media/Addresses_Icon.fa9fdc4e.svg";